import { Checkbox } from "@mui/material";
import { ACCEPTANCE_STATUS, TASK_LIST_TYPE } from "../constants/task.constants";
import { TimeSince } from "components/DateTime/TimeSince";
import { IconButtonForListWrapper } from "components/Wrappers/EditIcon/IconButtonForListWrapper";
import EditIcon from "@mui/icons-material/Edit";
import { MobileViewCellDataGrid } from "components/MobileViewCellDataGrid/MobileViewCellDataGrid";
import dayjs from "configs/dayjs.config";

import { Box } from "@mui/system";
import { dateTimeFormat } from "constants/componentsConstants";
import { SeeMore } from "components/Text/SeeMore";
import { TaskLogs } from "components/Logs/TaskLogs/TaskLogs";
import TaskPreviewModal from "components/Task/TaskPreviewModal";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";

export const taskListColumnsS = ({
  currentList,
  handleTaskCompletion,
  handleEdit,
  handleAssignTask,
  openLogModal,
  setOpenLogModal,
  logList,
  setLogList,
}) => [
  {
    accessorKey: "taskDetails",
    header: "Task Details",
    cell: ({ cell, row }) => (
      <>
        <MobileViewCellDataGrid
          tableData={[
            {
              label: (
                <FlexBox justifyContent="space-between" alignItems="center">
                  <Box>#</Box>
                  {currentList === TASK_LIST_TYPE.CREATED_BY_ME_PENDING.key && (
                    <IconButtonForListWrapper onClick={() => handleEdit(cell)}>
                      <EditIcon />
                    </IconButtonForListWrapper>
                  )}
                </FlexBox>
              ),
              data: (
                <TaskPreviewModal
                  task={{
                    title: row.original.docCode,
                    docDetails: row.original.docDetails,
                    detail: row.original.taskDetails,
                    description: row.original.taskDescription,
                    taskByName: row.original.taskByName,
                    taskToName: row.original.taskToName,
                    taskToOn: row.original.taskToOn,
                    acceptanceStatus: row.original.acceptanceStatus,
                    acceptanceOn: row.original.acceptanceOn,
                    acceptanceComment: row.original.acceptanceComment,
                    deadline: row.original.deadline,
                    doneStatus: row.original.doneStatus,
                    doneOn: row.original.doneOn,
                    acknowledgeStatus: row.original.acknowledgeStatus,
                    acknowledgeOn: row.original.acknowledgeOn,
                  }}
                >
                  <Box>
                    {row.original.docCode}
                    {row.original.docDetails && "- " + row.original.docDetails}
                  </Box>
                </TaskPreviewModal>
              ),
              action: "",
            },
            {
              label: (
                <FlexBox justifyContent="space-between" alignItems="center">
                  <Box>Task</Box>
                  {currentList === TASK_LIST_TYPE.CREATED_BY_ME_PENDING.key && (
                    <IconButtonForListWrapper onClick={() => handleEdit(cell)}>
                      <EditIcon />
                    </IconButtonForListWrapper>
                  )}
                </FlexBox>
              ),
              data: <SeeMore text={row.original.taskDetails} />,
              action: "",
            },
            {
              label: "Deadline",
              data: dayjs(row.original.deadline).format(dateTimeFormat.date),
              action: "",
            },
            {
              label: "By",
              data: (
                <>
                  {row.original.taskBy.label}
                  <TimeSince startDate={row.original.taskByOn} />
                </>
              ),
              action: "",
            },
            {
              label: (
                <FlexBox justifyContent="space-between" alignItems="center">
                  <Box>To</Box>
                  {row.original.acceptanceStatus !== "ACCEPTED" &&
                    row.original.subDocId !== 1 && (
                      <IconButtonForListWrapper
                        onClick={() => handleAssignTask(cell)}
                      >
                        <EditIcon />
                      </IconButtonForListWrapper>
                    )}
                </FlexBox>
              ),
              data: (
                <>
                  {row.original.taskTo.label}
                  <TimeSince startDate={row.original.taskToOn} />
                </>
              ),
              action: "",
            },
            {
              label: "Status",
              data: (
                <>
                  <Box>{ACCEPTANCE_STATUS[row.original.acceptanceStatus]}</Box>
                  <Box>
                    <TimeSince startDate={row.original.acceptanceOn} />
                  </Box>
                  <Box>
                    <SeeMore text={row.original.acceptanceComment} />
                  </Box>
                </>
              ),
              action: "",
            },
            {
              label: "Comment",
              data: row.original.acceptanceComment,
              action: "",
            },
            {
              label: "Done",
              data: row.original.doneStatus && (
                <TimeSince startDate={row.original.doneOn} />
              ),
              action: currentList !== TASK_LIST_TYPE.REJECTED.key &&
                row.original.acceptanceStatus === "ACCEPTED" && (
                  <Checkbox
                    disabled={
                      (currentList ===
                        TASK_LIST_TYPE.ASSIGNED_TO_ME_PENDING.key ||
                        currentList ===
                          TASK_LIST_TYPE.ASSIGNED_TO_ME_ACCEPTED.key) &&
                      !row.original.acknowledgeStatus
                        ? false
                        : true
                    }
                    checked={row.original.doneStatus ? true : false}
                    onClick={() =>
                      handleTaskCompletion(row.original.id, "DONE")
                    }
                  />
                ),
            },
            {
              label: "Ack.",
              data: row.original.acknowledgeStatus && (
                <TimeSince startDate={row.original.acknowledgeOn} />
              ),
              action: currentList !== TASK_LIST_TYPE.REJECTED.key &&
                row.original.doneStatus && (
                  <Checkbox
                    disabled={
                      currentList === TASK_LIST_TYPE.CREATED_BY_ME_PENDING.key
                        ? false
                        : true
                    }
                    checked={row.original.acknowledgeStatus ? true : false}
                    onClick={() => handleTaskCompletion(row.original.id, "ACK")}
                  />
                ),
            },
            {
              label: "Log",
              data: (
                <TaskLogs
                  key={row.original.id}
                  id={row.original.id}
                  updateCount={row.original.updateCount}
                  openLogModal={openLogModal}
                  setOpenLogModal={setOpenLogModal}
                  logList={logList}
                  setLogList={setLogList}
                />
              ),
              action: "",
            },
          ]}
        />
      </>
    ),
  },
];
